import type { AuditRule } from "../types";
import { brokenReferences } from "./brokenReferences";
import { inconsistentFormulas } from "./inconsistentFormulas";
import { hardcodedInFormulaColumn } from "./hardcodedInFormulaColumn";
import { whitespaceIssues } from "./whitespaceIssues";
import { externalLinks } from "./externalLinks";
import { dateFormatCells } from "./dateFormatCells";
import { cellTypeConflicts } from "./cellTypeConflicts";
import { selfSheetReference } from "./selfSheetReference";
import { hardcodeInFormulaBand } from "./hardcodeInFormulaBand";
import { hardcodedErrorLiteral } from "./hardcodedErrorLiteral";
import { inconsistentFormulaInBand } from "./inconsistentFormulaInBand";

export const systemAuditRules: AuditRule[] = [
  brokenReferences,
  inconsistentFormulas,
  hardcodedInFormulaColumn,
  whitespaceIssues,
  externalLinks,
  dateFormatCells,
  cellTypeConflicts,
  selfSheetReference,
  hardcodeInFormulaBand,
  hardcodedErrorLiteral,
  inconsistentFormulaInBand,
];
